import { useEffect } from 'react'
import { useSettingsStore } from '../store/settingsStore'

/** Keeps i18n aligned with persisted settings after zustand rehydrates. */
export default function SettingsHydrator() {
  const language = useSettingsStore((s) => s.language)

  useEffect(() => {
    const unsub = useSettingsStore.persist.onFinishHydration((state) => {
      if (!state.language) return
      void import('../i18n').then(({ default: i18n }) => {
        const lng = state.language.toLowerCase()
        if (i18n.language !== lng) {
          i18n.changeLanguage(lng)
        }
      })
    })

    if (useSettingsStore.persist.hasHydrated()) {
      void import('../i18n').then(({ default: i18n }) => {
        const lng = language.toLowerCase()
        if (i18n.language !== lng) {
          i18n.changeLanguage(lng)
        }
      })
    }

    return unsub
  }, [language])

  return null
}
